import { makeStyles } from '@material-ui/styles'

export const useRoundButtonStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#323639',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#424649',
    },
  },
}))
